import { createEvent, createStore } from 'effector';
import { defaultPagination } from '../constants';
import { type Pagination } from '../types/pagination';
import { alwaysNew } from './alwaysNew';

type CreatePaginationProps = {
    defaultPagination?: Pagination;
};

const defaultProps = {
    defaultPagination,
};

export const createPagination = ({
    defaultPagination = defaultProps.defaultPagination,
}: CreatePaginationProps = defaultProps) => {
    const setPage = createEvent<number>();
    const setPerPage = createEvent<number>();
    const setPagination = createEvent<Pagination>();
    const reset = createEvent();

    const $pagination = createStore<Pagination>(defaultPagination)
        .reset(reset)
        .on(setPagination, alwaysNew)
        .on(setPage, (state, page) => ({ ...state, page }))
        .on(setPerPage, (state, perPage) => ({ ...state, perPage }));

    return {
        $pagination,
        reset,
        setPage,
        setPerPage,
        setPagination,
    };
};

export type PaginationModel = ReturnType<typeof createPagination>;
